import { LogicalDeleteDTO } from '../basic/logicalDeleteDTO';
import { TenantDTO } from '../domain/tenant';

export class ChiusuraDTO extends LogicalDeleteDTO {
    id: number;
    tenant: TenantDTO;
    dataDa: Date;
    dataA: Date;
    descrizione: string;
}